<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{ $t('societes.libelleGeneratorProduit.title') }}
        </p>
      </section>
      <b-field
        :label="$t('societes.masqueBloc.' + typeLibelle)">
        <b-input v-model="masque" ref="masqueInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px">
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{REFERENCE}'">
            {REFERENCE}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.reference') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{FORMAT}'">
            {FORMAT}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.format') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{MATERIEL}'">
            {MATERIEL}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.materiel') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{ADRESSE}'">
            {ADRESSE}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.adresse') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{CONFRERE_COM}'">
            {CONFRERE_COM}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.confrereCom') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{CONFRERE_JUR}'">
            {CONFRERE_JUR}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.confrereJur') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="masque += '{ADRESSE_COMPLETE}'">
            {ADRESSE_COMPLETE}
          </p>
          <p class="has-text-default">
            {{ $t('societes.libelleGeneratorProduit.paramLibelleProduit.adresseComplete') }}
          </p>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.edit') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
    },
    typeLibelle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      masque: null,
    };
  },
  methods: {
    save() {
      this.$emit('updateLibelleGenerator', this.masque);
      this.$parent.close();
    },
  },
  mounted() {
    this.$refs.masqueInput.focus();
    this.masque = this.value ? this.value : '';
  },
};
</script>
